import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const rows = [{
  bad: 'No sabés cuánto ganás',
  good: 'Conocés tus números'
}, {
  bad: 'El dinero desaparece',
  good: 'Controlás cada peso'
}, {
  bad: 'Vivís improvisando',
  good: 'Tenés un plan financiero'
}, {
  bad: 'Tomás decisiones a ciegas',
  good: 'Decidís con información'
}, {
  bad: 'Sentís incertidumbre',
  good: 'Ganás tranquilidad'
}, {
  bad: 'Te cuesta crecer',
  good: 'Creás bases sólidas para crecer'
}];
export function ComparisonTable() {
  return <section className="py-20 bg-white" data-id="element-167">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-168">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-170">
            LA DIFERENCIA ENTRE SEGUIR SOLO O TENER UN SISTEMA
          </h2>
        </motion.div>

        <motion.div className="rounded-2xl overflow-hidden shadow-xl border border-slate-200" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-171">
          <div className="grid grid-cols-2 bg-navy-900 text-white text-center sticky top-0" data-id="element-172">
            <div className="p-4 md:p-6 font-bold text-sm md:text-lg border-r border-navy-800" data-id="element-173">
              SIN REINICIA TUS FINANZAS
            </div>
            <div className="p-4 md:p-6 font-bold text-sm md:text-lg bg-success text-white" data-id="element-174">
              CON REINICIA TUS FINANZAS
            </div>
          </div>

          <div className="bg-white" data-id="element-175">
            {rows.map((row, index) => <div key={index} className={`grid grid-cols-2 text-center ${index % 2 === 0 ? 'bg-slate-50' : 'bg-white'} hover:bg-slate-100 transition-colors`} data-id="element-176">
                <div className="p-4 md:p-6 border-r border-slate-200 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3" data-id="element-177">
                  <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-178" />
                  <span className="text-slate-600 font-medium text-sm md:text-base" data-id="element-179">
                    {row.bad}
                  </span>
                </div>
                <div className="p-4 md:p-6 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3" data-id="element-180">
                  <CheckCircle2 className="w-5 h-5 text-success flex-shrink-0" data-id="element-181" />
                  <span className="text-navy-900 font-bold text-sm md:text-base" data-id="element-182">
                    {row.good}
                  </span>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}